var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, observable, makeObservable } from 'mobx';
import { GroupSizePerformer } from './perform/GroupSizePerformer';
import { runtime } from '../../runtime/Runtime';
import { round } from '../../../utils/helper/lodash_replacements';
export class TextSizeGroup {
    parent;
    groupName;
    performer = new GroupSizePerformer(this);
    finalFontSize;
    constructor({ parent, groupName }) {
        makeObservable(this);
        this.parent = parent;
        this.groupName = groupName;
    }
    get app() {
        return this.parent.app;
    }
    get globalTextsizer() {
        return this.parent;
    }
    setFinalFontSize(finalFontSize) {
        this.finalFontSize = finalFontSize;
        if (!this.globalTextsizer.isMasterSizer)
            return;
        this.performer.groupItems.cachedChilds.forEach(element => {
            if (element && element.aspect) {
                const { currentScaledFontSize } = this.performer.groupItems;
                const { persistentAspect } = element.aspect;
                if (this.app.stage.stageInnerMeasure.stageHeightInPixel > 500) {
                    runtime.runtimeScheduler.addToNextIdleStateChange(() => {
                        persistentAspect.scaledValueOf.initialFontSize = round(currentScaledFontSize, 1);
                    });
                }
            }
        });
    }
}
__decorate([
    observable
], TextSizeGroup.prototype, "finalFontSize", void 0);
__decorate([
    action.bound
], TextSizeGroup.prototype, "setFinalFontSize", null);
